import { CardView } from '@leverege/ui-dashboard';
import { useSelector } from 'react-redux';
import { PortalOverlay } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import ResponsiveModel from "../responsive/ResponsiveModel.js";
import S from './ExpandedCardWrapper.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ExpandedCardWrapper(props) {
  const {
    model
  } = props;
  const expanded = useSelector(state => state.ui.expanded);
  let cardIsExpanded = expanded && expanded?.context?.clientProps?.dataViewerId === model?.content?.dataViewer?.id;
  if (!cardIsExpanded && model?.content?.dataViewer?.settings?.type === ResponsiveModel.TYPE) {
    const subDataViewer = model?.content?.dataViewer?.settings?.dataViewers;
    for (let i = 0; i < subDataViewer?.length; i++) {
      const subDataViewerId = subDataViewer?.[i]?.id;
      cardIsExpanded = expanded && expanded?.context?.clientProps?.dataViewerId === subDataViewerId;
      if (cardIsExpanded) {
        break;
      }
    }
  }
  if (cardIsExpanded) {
    return /*#__PURE__*/_jsx(PortalOverlay, {
      targetId: Config.get('expandedViewer', 'targetPortalId', 'expandedContainer'),
      show: true,
      showBackground: false,
      variant: "expandedViewer",
      className: S.expandedViewer,
      animation: "fade",
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(CardView, {
          ...props,
          dataProps: {
            'data-expanded': true
          }
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(CardView, {
    ...props
  });
}